import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

var PayAccountLogsPage = function (_super) {
  __extends(PayAccountLogsPage, _super);

  function PayAccountLogsPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.columns = [];
    _this.tbodyData = [];
    return _this;
  }

  PayAccountLogsPage.prototype.onPayIdChange = function (data) {
    if (data && data.length > 0) {
      this.queryPayAccountLogs();
    }
  };

  PayAccountLogsPage.prototype.created = function () {
    this.columns = [{
      title: this.t('时间'),
      dataIndex: 'add_time'
    }, {
      title: this.t('操作人'),
      dataIndex: 'add_user_name'
    }, {
      title: this.t('字段'),
      dataIndex: 'operate_type'
    }, {
      title: this.t('更新前'),
      dataIndex: 'before_value'
    }, {
      title: this.t('更新后'),
      dataIndex: 'after_value'
    }];
  };

  PayAccountLogsPage.prototype.queryPayAccountLogs = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, code, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.finance.queryPayAccountLogs({
              id: this.payId
            })];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data;
            this.tbodyData = data;
            this.tbodyData = this.$util.createTableRowKey(this.tbodyData);
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], PayAccountLogsPage.prototype, "payId", void 0);

  __decorate([Watch('payId', {
    immediate: true
  })], PayAccountLogsPage.prototype, "onPayIdChange", null);

  PayAccountLogsPage = __decorate([Component], PayAccountLogsPage);
  return PayAccountLogsPage;
}(Vue);

export default PayAccountLogsPage;